import React from 'react';
import { FormStateBasic } from 'informed';

import { LoadingWrapperWithFailure } from '@nw/shared/ui';

import { PublicRegistrationForm } from '../../../shared/components/PublicRegistrationForm';
import { CustomClassNamesInterface } from '../../../shared/types/MiscellaneousTypes';

import { UsePublicMachineReturnType } from '../../hooks/usePublicFormsMachine';
import {
  PublicFormMachineSendType,
  PublicFormMachineStateType
} from '../../machines/PublicFormsMachine/types';

import withPublicFormsMachine from './withPublicFormsMachine';

interface Props {
  formId: string;
  publicFormsMachineState: PublicFormMachineStateType;
  publicFormsMachineSend: PublicFormMachineSendType;
  status: UsePublicMachineReturnType['status'];
  errors: UsePublicMachineReturnType['errors'];
  onSuccessInitialConfig?: () => void;
  customHeader?: () => React.ReactElement;
  renderCustomSuccessPage?: (
    formValues: FormStateBasic['values'],
    publicFormMachineState: PublicFormMachineStateType,
    publicFormMachineSend: PublicFormMachineSendType
  ) => React.ReactElement;
  customClassNames: CustomClassNamesInterface;
}

class PublicRegistrationFormRoute extends React.Component<Props> {
  publicRegistrationFormRef: React.RefObject<unknown>;
  constructor(props: Props) {
    super(props);
    this.publicRegistrationFormRef = React.createRef();
  }

  renderPublicRegistrationForm = (): React.ReactElement | null => {
    const {
      publicFormsMachineState,
      publicFormsMachineSend,
      renderCustomSuccessPage,
      customHeader,
      onSuccessInitialConfig,
      customClassNames
    } = this.props;

    const formInfo = publicFormsMachineState.context.formInfo;

    if (formInfo) {
      onSuccessInitialConfig && onSuccessInitialConfig();
      return (
        <PublicRegistrationForm
          publicFormMachineState={
            publicFormsMachineState as PublicFormMachineStateType
          }
          publicFormMachineSend={publicFormsMachineSend}
          formConfig={formInfo}
          customClassNames={customClassNames}
          renderCustomSuccessPage={renderCustomSuccessPage}
          customHeader={customHeader}
        />
      );
    }
    return null;
  };

  override render() {
    const { status, errors } = this.props;
    return (
      <LoadingWrapperWithFailure
        apiStatus={status.getInitialConfigStatus}
        renderSuccessUI={this.renderPublicRegistrationForm}
        onRetry={() => {
          window.location.reload();
        }}
        apiError={errors.getInitialConfigError}
      />
    );
  }
}

export default withPublicFormsMachine(PublicRegistrationFormRoute);
